/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UpdateInitialPlanProjectInput = {
    id?: string | null | undefined;
    projectStartYear?: number | null | undefined;
    projectStartMonth?: number | null | undefined;
    projectStartDay?: number | null | undefined;
    projectEndYear?: number | null | undefined;
    projectEndMonth?: number | null | undefined;
    projectEndDay?: number | null | undefined;
    baselineWinChance?: number | null | undefined;
    baselineTarget?: number | null | undefined;
    baselineMinutesPerDay?: number | null | undefined;
    budget?: number | null | undefined;
    rateCardId?: string | null | undefined;
    taskCostCalculationType?: string | null | undefined;
    unassignedTaskHourlyCost?: number | null | undefined;
    baselineAdjustPrice?: number | null | undefined;
    baselineAdjustPercentage?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateInitialPlanProjectMutationVariables = {
    input: UpdateInitialPlanProjectInput;
};
export type UpdateInitialPlanProjectMutationResponse = {
    readonly updateInitialPlanProject: {
        readonly project: {
            readonly id: string;
            readonly baselineTargetMinutes: number | null;
            readonly baselineTargetPrice: number | null;
            readonly baselineCost: number | null;
            readonly baselineProfit: number | null;
            readonly baselineWinChance: number | null;
            readonly projectStartYear: number | null;
            readonly projectStartMonth: number | null;
            readonly projectStartDay: number | null;
            readonly projectEndYear: number | null;
            readonly projectEndMonth: number | null;
            readonly projectEndDay: number | null;
            readonly baselineTarget: number | null;
            readonly baselineEstimationMinutesPerDay: number | null;
            readonly budget: number | null;
            readonly rateCard: {
                readonly id: string;
                readonly currency: string | null;
            } | null;
            readonly unassignedTaskHourlyCost: number | null;
            readonly taskCostCalculationType: string | null;
            readonly phases: {
                readonly edges: ReadonlyArray<{
                    readonly " $fragmentRefs": FragmentRefs<"PhasesSection_phases">;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type UpdateInitialPlanProjectMutation = {
    readonly response: UpdateInitialPlanProjectMutationResponse;
    readonly variables: UpdateInitialPlanProjectMutationVariables;
};



/*
mutation UpdateInitialPlanProjectMutation(
  $input: UpdateInitialPlanProjectInput!
) {
  updateInitialPlanProject(input: $input) {
    project {
      id
      baselineTargetMinutes
      baselineTargetPrice
      baselineCost
      baselineProfit
      baselineWinChance
      projectStartYear
      projectStartMonth
      projectStartDay
      projectEndYear
      projectEndMonth
      projectEndDay
      baselineTarget
      baselineEstimationMinutesPerDay
      budget
      rateCard {
        id
        currency
      }
      unassignedTaskHourlyCost
      taskCostCalculationType
      phases(first: 100000) {
        edges {
          ...PhasesSection_phases
          cursor
          node {
            __typename
            id
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}

fragment ExpenseRow_phaseBaselineExpense on PhaseBaselineExpenseType {
  id
  phaseId
  expenseCategory {
    id
    name
  }
  expenseCost
  expenseMarkup
  expenseRevenue
  expenseProfit
}

fragment Phase_phase on PhaseType {
  id
  name
  baselineTargetPrice
  baselineTargetMinutes
  baselineCost
  baselineProfit
  startYear
  startMonth
  startDay
  deadlineYear
  deadlineMonth
  deadlineDay
  baselineStartYear
  baselineStartMonth
  baselineStartDay
  baselineDeadlineYear
  baselineDeadlineMonth
  baselineDeadlineDay
  phaseBaselineRoles(first: 100000) {
    edges {
      node {
        id
        ...RoleRow_phaseBaselineRole
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  phaseBaselineExpenses(first: 100000) {
    edges {
      node {
        id
        ...ExpenseRow_phaseBaselineExpense
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment PhasesSection_phases on PhaseTypeEdge {
  node {
    id
    ...Phase_phase
    startYear
    startMonth
    startDay
    deadlineYear
    deadlineMonth
    deadlineDay
  }
}

fragment RoleRow_phaseBaselineRole on PhaseBaselineRoleType {
  id
  phaseId
  role {
    id
    name
  }
  baselineMinutes
  baselinePrice
  baselineRatePerHour
  baselineCost
  baselineCostPerHour
  baselineProfit
  startYear
  startMonth
  startDay
  deadlineYear
  deadlineMonth
  deadlineDay
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInitialPlanProjectInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetMinutes",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetPrice",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTarget",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineEstimationMinutesPerDay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unassignedTaskHourlyCost",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskCostCalculationType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseId",
  "storageKey": null
},
v32 = [
  (v2/*: any*/),
  (v24/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateInitialPlanProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInitialPlanProjectPayload",
        "kind": "LinkedField",
        "name": "updateInitialPlanProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": "phases",
                "args": null,
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "__Project_phases_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PhasesSection_phases"
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateInitialPlanProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInitialPlanProjectPayload",
        "kind": "LinkedField",
        "name": "updateInitialPlanProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v24/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "PhaseBaselineRoleTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineRoles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineRoleTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineRoleType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Role",
                                        "kind": "LinkedField",
                                        "name": "role",
                                        "plural": false,
                                        "selections": (v32/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineMinutes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselinePrice",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineRatePerHour",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineCostPerHour",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": "phaseBaselineRoles(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Phase_phaseBaselineRoles",
                            "kind": "LinkedHandle",
                            "name": "phaseBaselineRoles"
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "PhaseBaselineExpenseTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineExpenses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineExpenseTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineExpenseType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExpenseCategory",
                                        "kind": "LinkedField",
                                        "name": "expenseCategory",
                                        "plural": false,
                                        "selections": (v32/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseCost",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseMarkup",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseRevenue",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseProfit",
                                        "storageKey": null
                                      },
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": "phaseBaselineExpenses(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Phase_phaseBaselineExpenses",
                            "kind": "LinkedHandle",
                            "name": "phaseBaselineExpenses"
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": "phases(first:100000)"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateInitialPlanProject",
            "project",
            "phases"
          ]
        }
      ]
    },
    "name": "UpdateInitialPlanProjectMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateInitialPlanProjectMutation(\n  $input: UpdateInitialPlanProjectInput!\n) {\n  updateInitialPlanProject(input: $input) {\n    project {\n      id\n      baselineTargetMinutes\n      baselineTargetPrice\n      baselineCost\n      baselineProfit\n      baselineWinChance\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      baselineTarget\n      baselineEstimationMinutesPerDay\n      budget\n      rateCard {\n        id\n        currency\n      }\n      unassignedTaskHourlyCost\n      taskCostCalculationType\n      phases(first: 100000) {\n        edges {\n          ...PhasesSection_phases\n          cursor\n          node {\n            __typename\n            id\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment ExpenseRow_phaseBaselineExpense on PhaseBaselineExpenseType {\n  id\n  phaseId\n  expenseCategory {\n    id\n    name\n  }\n  expenseCost\n  expenseMarkup\n  expenseRevenue\n  expenseProfit\n}\n\nfragment Phase_phase on PhaseType {\n  id\n  name\n  baselineTargetPrice\n  baselineTargetMinutes\n  baselineCost\n  baselineProfit\n  startYear\n  startMonth\n  startDay\n  deadlineYear\n  deadlineMonth\n  deadlineDay\n  baselineStartYear\n  baselineStartMonth\n  baselineStartDay\n  baselineDeadlineYear\n  baselineDeadlineMonth\n  baselineDeadlineDay\n  phaseBaselineRoles(first: 100000) {\n    edges {\n      node {\n        id\n        ...RoleRow_phaseBaselineRole\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  phaseBaselineExpenses(first: 100000) {\n    edges {\n      node {\n        id\n        ...ExpenseRow_phaseBaselineExpense\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PhasesSection_phases on PhaseTypeEdge {\n  node {\n    id\n    ...Phase_phase\n    startYear\n    startMonth\n    startDay\n    deadlineYear\n    deadlineMonth\n    deadlineDay\n  }\n}\n\nfragment RoleRow_phaseBaselineRole on PhaseBaselineRoleType {\n  id\n  phaseId\n  role {\n    id\n    name\n  }\n  baselineMinutes\n  baselinePrice\n  baselineRatePerHour\n  baselineCost\n  baselineCostPerHour\n  baselineProfit\n  startYear\n  startMonth\n  startDay\n  deadlineYear\n  deadlineMonth\n  deadlineDay\n}\n"
  }
};
})();
(node as any).hash = 'aacbca8eb6d63f0cf7b7b93d37551ed6';
export default node;
